import { css } from 'styled-components';

export const PaymentPlanSkeleton = css(
  ({ theme }) => css`
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 26px;
    box-sizing: border-box;

    > .content {
      display: flex;
      align-items: center;
      width: 100%;
      gap: 20px;

      > .text {
        font-weight: 800;
        font-size: 30px;
        line-height: 44px;
        color: ${theme.colors.white};

        > .currency-wrapper {
          vertical-align: text-bottom;

          > .currency {
            font-weight: 600;
            font-size: 30px;
          }
        }

        > .separator {
          font-size: 30px;
        }
      }
    }
  `
);
